import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

const list = Array.from(new Array(6));

export default function SkeletonResult({ cardsPerRow = 4 }) {
  return (
    <Grid container spacing={3}>
      {list.map((item, index) => (
        <Grid key={index} size={{ lg: cardsPerRow === 3 ? 4 : 3, md: 6, sm: 6, xs: 12 }}>
          <Box sx={{ aspectRatio: "4/3", width: "100%" }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{ backgroundColor: "#f8f9fb" }}
            />
          </Box>
          <Box pt={2}>
            <Skeleton width="70%" />
            <Skeleton width="60%" />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
